import React from "react";
import Container from "../ui/Container";
import Button from "../ui/Button";
import { BRAND } from "../../lib/config";
import { ArrowUpRight, Users } from "lucide-react";

export default function WebHostingCTA() {
  return (
    <section className="bg-[#070A0F] pb-24 pt-10">
      <Container>
        <div className="mx-auto max-w-4xl text-center">
          <div className="text-xs font-semibold tracking-wider text-white/50">READY</div>
          <h3 className="mt-3 text-balance text-4xl font-semibold leading-[0.95] tracking-tight text-white sm:text-5xl lg:text-6xl">
            Launch your site today<span className="text-cyan-300">.</span>
          </h3>
          <p className="mx-auto mt-5 max-w-2xl text-white/70 sm:text-lg">
            Start simple. Upgrade when you grow. Get human support when you need it.
          </p>

          <div className="mt-10 flex flex-col items-center justify-center gap-3 sm:flex-row">
            <Button href={BRAND.deployUrl} className="w-full sm:w-auto">
              Get Web Hosting <ArrowUpRight className="h-4 w-4 opacity-80" />
            </Button>
            <Button variant="secondary" href={BRAND.discordUrl} className="w-full sm:w-auto">
              Ask in Discord <Users className="h-4 w-4 opacity-70" />
            </Button>
          </div>
        </div>
      </Container>
    </section>
  );
}
